 /* istanbul ignore next */
export function ParseDate( date:Date, timeZone: number ): Date {

    let d = new Date(date);

    let currentTimeZone = timeZone.toString();

    if (currentTimeZone.indexOf(".") === -1)
    {
        d.setHours(d.getHours() + parseInt(currentTimeZone));
        return d;
    }

    let hoursDiff = parseInt(currentTimeZone);
    let minutesDiff = (parseFloat(currentTimeZone) - hoursDiff) * 60;

    d.setHours(d.getHours() + hoursDiff, d.getMinutes() + minutesDiff);
    return d;
}
